import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';
import toast from 'react-hot-toast';

const ToastTester = () => {
  const showToast = (type) => {
    const message = `This is a ${type} toast message`;
    toast.dismiss();
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'warning':
      case 'info':
        toast(message, { type });
        break;
      default:
        toast(message);
    }
  };

  const toastTypes = [
    { type: 'success', icon: CheckCircle, color: 'border-success-500/25 bg-success-50 text-success-700 hover:bg-success-100 dark:bg-success-500/10 dark:text-success-400 dark:hover:bg-success-500/15', label: 'Success Toast' },
    { type: 'error', icon: XCircle, color: 'border-danger-500/25 bg-danger-50 text-danger-700 hover:bg-danger-100 dark:bg-danger-500/10 dark:text-danger-400 dark:hover:bg-danger-500/15', label: 'Error Toast' },
    { type: 'warning', icon: AlertTriangle, color: 'border-warning-500/30 bg-warning-50 text-warning-700 hover:bg-warning-100 dark:bg-warning-500/10 dark:text-warning-400 dark:hover:bg-warning-500/15', label: 'Warning Toast' },
    { type: 'info', icon: Info, color: 'border-info-500/25 bg-info-50 text-info-700 hover:bg-info-100 dark:bg-info-500/10 dark:text-info-400 dark:hover:bg-info-500/15', label: 'Info Toast' }
  ];

  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-gray-900 dark:text-gray-100">Toast Notification Tester</h2>
      <p className="mb-6 text-sm text-gray-600 dark:text-gray-400">Test different types of toast notifications to ensure proper styling and behavior.</p>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {toastTypes.map(({ type, icon: Icon, color, label }) => (
          <button
            key={type}
            onClick={() => showToast(type)}
            className={`${color} flex flex-col items-center gap-2 rounded-xl border p-4 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/60`}
          >
            <Icon className="h-5 w-5" />
            <span className="text-sm font-medium">{label}</span>
          </button>
        ))}
      </div>

      <div className="mt-6 rounded-lg border border-gray-200/70 bg-gray-50 p-4 dark:border-white/[0.07] dark:bg-white/[0.03]">
        <h3 className="mb-2 text-sm font-semibold text-gray-900 dark:text-gray-100">Toast Testing Guidelines:</h3>
        <ul className="space-y-1 text-sm text-gray-600 dark:text-gray-400 [&_strong]:font-semibold [&_strong]:text-gray-700 dark:[&_strong]:text-gray-300">
          <li>• <strong>Success:</strong> For successful operations (save, update, etc.)</li>
          <li>• <strong>Error:</strong> For failures and critical issues</li>
          <li>• <strong>Warning:</strong> For caution messages and non-critical issues</li>
          <li>• <strong>Info:</strong> For general information and tips</li>
        </ul>
      </div>
    </div>
  );
};

export default ToastTester;
